import { render, staticRenderFns } from "./BranchSuperAdminHub.vue?vue&type=template&id=c6f1cf36"
import script from "./BranchSuperAdminHub.vue?vue&type=script&lang=js"
export * from "./BranchSuperAdminHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports